<h3 color="primary" class="popup-header">Logs</h3>
<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="isFromPatient">
    <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
      [allowSorting]="true" [pageSettings]="pageSettings">
      <e-columns>
        <e-column field='viewDate' headerText='Date' width=15></e-column>
        <e-column field='userName' headerText='User' width=30></e-column>
        <e-column field='changeLog' headerText='Changes' width=80></e-column>
      </e-columns>
    </ejs-grid>
    <app-total-record-count [count]="dataList.length"></app-total-record-count>
  </ng-container>

  <ng-container *ngIf="!isFromPatient">
    <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
      [allowSorting]="true" [pageSettings]="pageSettings" (dataStateChange)='dataStateChange($event)'>
      <e-columns>
        <e-column field='createdDateTime' headerText='Date' width=15>
          <ng-template #template let-data>
            {{data.createdDateTime | date:'MM/dd/yyyy'}}
          </ng-template>
        </e-column>
        <e-column field='userName' headerText='User' width=30></e-column>
        <e-column field='changeLog' headerText='Changes' width=80></e-column>
      </e-columns>
    </ejs-grid>
    <app-total-record-count [count]="dataList.count"></app-total-record-count>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>